import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { ThemeProvider } from "@emotion/react";
import { StageLegacy, ContentArticle } from "@silvertours/front-features";
import { Theme } from "@silvertours/front-shared";
import { Body } from "../body";
/**
 * This is a page template that only renders search form, introduction and content modules.
 * Create for black friday promo page, but can be used for rendering other pages where we don't
 * want to render legacy elements. To use the template, add necessary slug in i18n/json/app/pageContent/[LOCALE].ts
 */ var PlainPage = function(_param) {
    var _content = _param.content, article = _content.article, introduction = _content.introduction, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = _object_without_properties(_param, [
        "content"
    ]);
    var t = useTranslations("features");
    var translations = t.raw("article");
    var ref;
    return /*#__PURE__*/ _jsx(Body, _object_spread({
        title: primaryHeadline,
        stage: /*#__PURE__*/ _jsx(StageLegacy.Stage, {
            content: stage.content
        }),
        content: function(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            return [
                containerModule("introduction-content", /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: Theme.defaultTheme,
                    children: /*#__PURE__*/ _jsx(ContentArticle, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                container("content-modules", [
                    contentModule("article", /*#__PURE__*/ _jsx(ThemeProvider, {
                        theme: Theme.defaultTheme,
                        children: /*#__PURE__*/ _jsx(ContentArticle, {
                            modules: article.segments,
                            translations: translations
                        })
                    })), 
                ]), 
            ];
        },
        includeSearch: stage.content.includeSearch
    }, commonProps));
};
export { PlainPage };
